import { useCallback } from 'react';

import { getChannelLabel } from 'src/data/channel';
import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { ExportAssetNamePopup } from './ExportAssetNamePopup';

const POPUP_KEY = Symbol('EXPORT_ASSET_NAME');

export const useExportAssetNamePopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(POPUP_KEY, ExportAssetNamePopup);
  });

  const openExportAssetNamePopup = useCallback(
    (channel) => {
      const title = `Export to ${getChannelLabel(channel)}`;
      return new Promise((resolve) => {
        popups.openPopup(POPUP_KEY, {
          title,
          onSubmit: (value) => {
            popups.closePopup(POPUP_KEY);
            resolve(value);
          },
          onCancel: () => {
            popups.closePopup(POPUP_KEY);
            resolve(null);
          },
        });
      });
    },
    [popups]
  );

  return { openExportAssetNamePopup };
};
